import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { DateListener } from '@zenlayer/util';

var AccountClass = /*#__PURE__*/_createClass(function AccountClass() {
  var _this = this;

  _classCallCheck(this, AccountClass);

  _defineProperty(this, "dateListener", void 0);

  _defineProperty(this, "getAccount", function () {
    return _this.dateListener.getValue();
  });

  _defineProperty(this, "setAccount", function (account) {
    _this.dateListener.setValue(account);
  });

  _defineProperty(this, "useAccount", function () {
    return _this.dateListener.useValueListener();
  });

  this.dateListener = new DateListener('console_account', {
    setWindow: true
  });
});

var _AccountClass = new AccountClass(),
    getAccount = _AccountClass.getAccount,
    setAccount = _AccountClass.setAccount,
    useAccount = _AccountClass.useAccount;

export { getAccount, setAccount, useAccount };